import React, { useEffect, useState } from 'react';
import { parsePrice } from '../../utils';
import { TableCell, TextField } from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import {
  TypeLayer,
  TypeRow,
  TypeVendorInfo
} from '../../types/WorkingBudgetPage';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  btnColor,
  mainBlueColor,
  workingBudgetData,
  workingBudgetVendor,
  saveTimeStateData
} from '../../GlobalState';
import _ from 'lodash';
import { recalculation } from '../../utils/WorkingBudgetPage';
import { InputArea } from './InputArea';
import NumberInput from '../../components/NumberInput';
import {
  LOCAL_WORKING_BUDGET_KEY,
  LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY
} from '../../const/Const';
import { useParams } from 'react-router-dom';

const StyledTableCell = withStyles(theme => ({
  root: {
    backgroundColor: '#FFF'
  },
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

type TProps = {
  data: TypeRow;
  vender: TypeVendorInfo;
  layer_key: string;
  workingBudgetId: number;
};

export const Vender: React.FC<TProps> = (props: TProps) => {
  const { data, vender, layer_key, workingBudgetId } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);
  const [vendor, setVendor] = useRecoilState(workingBudgetVendor);
  const [additionalCost] = useRecoilState(additionalCostData);
  const classes = useStyles({ mainColor: mainColor });
  const price =
    data.vendor_order_price.length > 0
      ? data.vendor_order_price.find(item => item.vendor_id == vender.vendor_id)
      : 0;
  const [inputPrice, setInputPrice] = useState<number>(
    price ? price.order_price : 0
  );
  const [saveTime, setSaveTime] = useRecoilState(saveTimeStateData);
  const params: any = useParams();

  useEffect(() => {
    setInputPrice(price ? price.order_price : 0);
  }, [price]);

  const onInputChange = (val: any) => {
    const inputVal = /^[0-9]+$/.test(val.target.value)
      ? Number(val.target.value)
      : 0;
    const cloneWorkingBudget: TypeLayer | undefined =
      _.cloneDeep(workingBudget);
    if (cloneWorkingBudget) {
      const workingBudgetIndex = cloneWorkingBudget[layer_key].findIndex(
        i => i.id == data.id
      );
      const venderIndex = cloneWorkingBudget[layer_key][
        workingBudgetIndex
      ].vendor_order_price.findIndex(i => i.vendor_id == vender.vendor_id);
      if (venderIndex == -1) {
        cloneWorkingBudget[layer_key][
          workingBudgetIndex
        ].vendor_order_price.push({
          vendor_id: vender.vendor_id,
          order_price: inputVal,
          target_item_id: data.id ? data.id : 0
        });
      } else {
        cloneWorkingBudget[layer_key][workingBudgetIndex].vendor_order_price[
          venderIndex
        ].order_price = inputVal;
      }

      setWorkingBudget(cloneWorkingBudget);
      setInputPrice(inputVal);
    }
  };

  // ローカルストレージで保存する際のキー(実行予算用)
  // 新規作成：working_budget_id_実行予算ID / 編集：working_budget_実行予算ID
  const setKey = params.id
    ? LOCAL_WORKING_BUDGET_KEY + params.id
    : LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY + workingBudgetId;
  /**
   * ローカルストレージへの保存処理
   * @param key
   * @param value
   */
  const setLocalStorage = (
    key: 'order_price' | 'target_item_id' | 'time',
    value: string
  ) => {
    let setData = {
      order_price: '',
      target_item_id: '',
      time: ''
    };

    // ローカルストレージのデータを取得
    const localStorageData = localStorage.getItem(setKey);

    // ローカルストレージのデータが存在する場合
    if (localStorageData) {
      // 設定データに取得した既存データを設定
      setData = JSON.parse(localStorageData);
    }

    // 対象のキーの値を更新
    setData[key] = value;

    // 保存時間を設定
    const now = new Date();
    const time = `${now.getFullYear()}/${('0' + (now.getMonth() + 1)).slice(
      -2
    )}/${('0' + now.getDate()).slice(-2)} ${('0' + now.getHours()).slice(
      -2
    )}:${('0' + now.getMinutes()).slice(-2)}:${('0' + now.getSeconds()).slice(
      -2
    )}`;
    setData.time = time;

    const object = {
      additionalCost: additionalCost,
      workingBudget: workingBudget,
      time: time
    };

    localStorage.setItem(setKey, JSON.stringify(object));
    setSaveTime(time);
  };

  return (
    <StyledTableCell
      className={classes.tableInput}
      style={{ width: 150, border: '0.5px #CCCCCC solid' }}
      align='right'
    >
      {data.has_under_layer_flg == 1 ? (
        <>{parsePrice(price ? price.order_price : 0)}</>
      ) : (
        <InputArea
          onChange={onInputChange}
          onBlur={(text: any) => {
            const cloneWorkingBudget: TypeLayer | undefined =
              _.cloneDeep(workingBudget);
            const vender: TypeVendorInfo[] | undefined = _.cloneDeep(vendor);
            if (cloneWorkingBudget && vender) {
              recalculation(
                cloneWorkingBudget,
                vender,
                setWorkingBudget,
                setVendor,
                additionalCost
              );
            }
            setLocalStorage('order_price', text);
          }}
          inputPrice={inputPrice !== 0 ? inputPrice.toString() : ''}
        />
      )}
    </StyledTableCell>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    tableInput: {
      padding: 8,
      paddingBottom: 3
    }
  })
);
